import { createContext, useContext } from 'react'
import { useForm } from 'uniforms'

export const CiboAutoFormContext = createContext<{
  warnings?: Record<string, string>
  touch: (name: string) => void
  touched: Record<string, boolean>
  displays?: string[]
  isFieldRequired?: (name: string) => boolean
}>({ touched: {}, touch: () => {} })

export const useCiboAutoForm = () => {
  const form = useForm()
  const context = useContext(CiboAutoFormContext)

  return { ...form, ...context }
}
